"use strict";

import $ from "jquery";

const toggleNav = function () {
  $(".main-nav").toggleClass("shown");
};

$(document).on("turbolinks:load", function () {
  $(".main-nav-sm a").on("click", toggleNav);
});
